import React from "react";

import "./style.less";

import DateTimePickerCommon, {
  type DateTimePickerProps as DateTimePickerPropsCommon
} from "@common/controls/Inputs/DateTimePicker/component";

export type DateTimePickerProps = Omit<DateTimePickerPropsCommon, "context">;
const DateTimePicker = ({ showClear, ...props }: DateTimePickerProps) => (
  <DateTimePickerCommon {...props} showClear={showClear ?? true} />
);
export default DateTimePicker;
